import { Driver } from './Driver';
import { Unit, UnitStatus } from './Unit';
interface User {
  id: number; // ID
  name: string;
  crt: number; // creator ID
  bact: number; // account ID
}
export class Session {
  sid: string;
  parent: string;
  driver: Driver;
  services: any[];
  policyChecked: boolean;
  platformAccount: { id: number, name: string };
  user: { id: number, name: string, crt: number, bact: number };
  unit?: Unit;
  jwt?: string;
}
export class AdminSession {
  platformToken: string;
  parent: string;
  jwt: string;
  sid: string;
  services: ServiceSession[];
  policyChecked: boolean;
  user: User;
}
export class ConfigurationService {
  version: string;
  FIND_ROUTES_BY_LOCATION: boolean;
  FIND_ROUTES_RADIO_MTS: number;
  PACKAGES_TITLE_NAME: string;
  PACKAGES_LOAD_METHOD: 'CHECKBOX' | 'SCANNER';
  ACCESS_TOKEN?: string;
  CAN_REMOVE_PACKAGES?: boolean;
  CAN_DELETE_TASKS?: boolean;
  SHOW_DRIVER_PROFILE: string;
}
export class ServiceSession {
  name: Services;
  active: boolean;
  config: ConfigurationService;
}
export const SERVICES = {
  TACHO_SEND: 'Tacho-Send',
  ASSISTANT_CHAT: 'Assistant-Chat',
  ASSISTANT_PRIVACITY: 'Assistant-Privacity',
  ASSISTANT_GPS: 'Assistant-Gps',
  ASSISTANT_TRIPS: 'Assistant-Trips',
  ASSISTANT_ROUTES: 'Assistant-Routes',
  ASSISTANT_ROUTES_PRO: 'Assistant-Routes-Pro',
  ASSISTANT_FORMS: 'Assistant-Forms',
  ASSISTANT_BUSCONTROL: 'Assistant-Buscontrol',
  ASSISTANT_CARPOOLING: 'Assistant-Carpooling',
  ASSISTANT_COSTS: 'Assistant-Costs',
  ASSISTANT_TEMPCHECK: 'Assistant-Tempcheck',
  ASSISTANT_FILES: 'Assistant-Files',
  MOVERTIS_API: 'Movertis-Api',
  ASSISTANT_ACTIVEROUTES: 'Assistant-Activeroutes',
  MOVERTIS_TIMES: 'Movertis-times',
  MOVERTIS_IMPORT_DRIVERS: 'Movertis-import-drivers',
  SUPRAGAMBOA_TASKS_S3_IMPORT_FILE: 'S3_Tasks_Import_File',
  SUPRAGAMBOA_TASKS_OPTIMIZATION: 'Tasks_Optimization',
  MOVERTIS_IMPORT_REFUELING: 'Movertis-import-refueling',
  ASSISTANT_MAINTENANCES: 'Assistant-Maintenances',
  ASSISTANT_FICHAJES: 'Assistant-Clocking',
  MOVERTIS_TACO360: 'Movertis-Tacho-360',
  ASSISTANT_MOBILE: 'Assistant-Mobile',
  MOVERTIS_CAES: 'Movertis-Caes',
} as const;
export type Services = typeof SERVICES[keyof typeof SERVICES];
export type SessionStatus = {
  init: number;
  unit?: UnitStatus;
}
